"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { FormReportConstants } from 'Constants/Forms/FormReportConstants';
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { Fields, System } from "Constants/objects";
import { Map, Record } from "immutable";
import { Model } from "Model";
import { Collection } from "Collection";
import { formDestroyed } from "Actions/Forms/FormActions";
import { formReportApply, formReportUpdate } from "Actions/Forms/FormReportActions";
import { Messages } from "Messages";
import { loadFormFields, loadFormMetadata } from "D5Utils/common_requests";
import router from 'Router';
import FieldsFactory from "D5Utils/FieldsFactory";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { formatDateToAPI, formatMessage, getControlDXType, getD5EditorType, getDatePlaceholder, getDisplayObjectFieldIDName, getFieldFormat, getKeyObjFieldName, getLinkedName, getTitlePosition, isEmptyObject } from "D5Utils/functions";
import FormStateManager from "D5Utils/FormStateManager";
var ReportStore = Record({
  formID: null,
  rowID: null,
  type: null,
  initialized: false,
  title: '',
  name: '',
  objectName: '',
  objectFields: null,
  fieldGroupsData: null,
  formInst: null,
  popupInst: null,
  viewMode: System.VIEW_MODE.MODAL,
  updating: false,
  formData: null,
  tableUUID: '',
  reportUrl: '',
  stateManager: null
});

var _stores = Map();

var CHANGE_EVENT = 'change';

var FormReportStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(FormReportStoreClass, _StoreClass);

  function FormReportStoreClass() {
    _classCallCheck(this, FormReportStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormReportStoreClass).apply(this, arguments));
  }

  _createClass(FormReportStoreClass, [{
    key: "getInitList",
    value: function getInitList() {
      return new ReportStore().toObject();
    }
    /**
     * @return {*|Map<any, any>|Map<string, string>}
     */

  }, {
    key: "getList",
    value: function getList(uuid) {
      return _stores.get(uuid).toObject();
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(name, UUID) {
      var objectFields = _stores.get(UUID).get('objectFields');

      return _.find(objectFields, function (item) {
        return item.Name === name;
      });
    }
  }, {
    key: "getFieldByObjectName",
    value: function getFieldByObjectName(name, UUID) {
      var objectFields = _stores.get(UUID).get('objectFields');

      return _.find(objectFields, function (item) {
        return item[Fields.ObjectFieldID_Name] === name;
      });
    }
  }, {
    key: "navigateToParent",
    value: function navigateToParent(UUID) {
      setTimeout(function () {
        return formDestroyed(UUID);
      });
    }
    /**
     * @param {object} options
     */

  }, {
    key: "createSelectFieldDS",
    value: function createSelectFieldDS(options) {
      var _this = this;

      var dictObj = options.dictObj,
          dictKeyFld = options.dictKeyFld,
          dictDisplayFld = options.dictDisplayFld;
      return new DevExpress.data.DataSource({
        paginate: true,
        pageSize: 10,
        store: new DevExpress.data.CustomStore({
          load: function load(loadOptions) {
            return _this.getSelectFieldData(loadOptions, options);
          },
          byKey: function byKey(key) {
            if (Array.isArray(key) && !key.length) return Promise.resolve();
            return new Promise(function (resolve) {
              var ObjectModel = Model.extend({
                initialize: function initialize() {
                  this.object = dictObj;
                }
              });
              new ObjectModel().fetch({
                data: {
                  Columns: [dictKeyFld, dictDisplayFld],
                  Filters: _defineProperty({}, dictKeyFld, {
                    '=': key
                  }),
                  Sorts: [dictDisplayFld]
                },
                success: function success(res) {
                  resolve(res.toJSON());
                }
              });
            });
          }
        })
      });
    }
    /**
     * @param {object} loadOptions
     * @param {object} options
     * @return {Promise}
     */

  }, {
    key: "getSelectFieldData",
    value: function getSelectFieldData(loadOptions, options) {
      var dictObj = options.dictObj,
          dictKeyFld = options.dictKeyFld,
          dictDisplayFld = options.dictDisplayFld,
          dataField = options.dataField,
          UUID = options.UUID;
      return new Promise(function (resolve) {
        var objectModel = Model.extend({
          initialize: function initialize() {
            this.object = dictObj;
          }
        });
        var objectCollection = new (Collection.extend({
          model: objectModel,
          object: dictObj
        }))();
        var fltr = {};

        var store = _stores.get(UUID);

        var formData = store.get('formData');
        var value = formData && formData[dataField] || [];

        if (loadOptions.filter != null && isEmptyObject(value)) {
          fltr = _defineProperty({}, dictKeyFld, {
            '=': value
          });
        }

        objectCollection.fetch({
          data: {
            Page: (loadOptions.skip + loadOptions.take) / loadOptions.take || -1,
            RowsPerPage: loadOptions.take,
            Columns: [dictKeyFld, dictDisplayFld],
            Filters: fltr,
            Sorts: [dictDisplayFld]
          },
          success: function success(collection) {
            var col = collection.toJSON();
            resolve(col);
          }
        });
      });
    }
    /**
     * @param {string} UUID
     * @param {object} sourceData
     * @return {object}
     */

  }, {
    key: "sourceDataToForm",
    value: function sourceDataToForm(UUID, sourceData) {
      var formData = {};

      for (var prop in sourceData || {}) {
        if (sourceData.hasOwnProperty(prop)) {
          var field = this.getFieldByObjectName(prop, UUID);

          if (!field) {
            console.warn(formatMessage(Messages.Warning.CustomParamByFN, [prop]));
            continue;
          }

          var objFldName = field[Fields.ObjectFieldID_Name];
          var fieldName = field[Fields.Name];

          if (objFldName === prop) {
            if (Array.isArray(sourceData[prop])) {
              formData[fieldName] = sourceData[prop].filter(function (item) {
                return item != null;
              }).join(',');
              formData[fieldName] = decodeURI(sourceData[prop]);
            } else if (typeof sourceData[prop] === 'string') {
              formData[fieldName] = decodeURI(sourceData[prop]);
            } else {
              formData[fieldName] = sourceData[prop];
            }
          }
        }
      }

      var store = _stores.get(UUID);

      var stateManager = store.get('stateManager');
      var stateData = stateManager.getProperty(System.FORM_STATE_PROPS.FIELDS) || {};
      formData = _objectSpread({}, stateData, formData);
      return formData;
    }
  }, {
    key: "initForm",
    value: function initForm(_ref) {
      var UUID = _ref.UUID;
      var items = this.prepareFields(UUID);

      var store = _stores.get(UUID);

      var that = this;
      var data = store.get('formData');
      var form = $(store.get('formInst')).dxForm({
        formData: data,
        items: [items],
        labelLocation: 'left',
        tabIndex: -1,
        onInitialized: function onInitialized(e) {},
        onEditorEnterKey: function onEditorEnterKey(e) {
          if (e.event.ctrlKey && e.event.keyCode === 13) {
            //Ctrl+Enter
            e.component.getEditor(e.dataField).blur(); //для того чтобы обновилось значение поля

            formReportApply(UUID);
          }
        },
        onContentReady: function onContentReady(e) {
          var _this2 = this;

          //таймаут потому что форма загружается раньше чем показывается попап, взято из примера поддержки либы
          setTimeout(function () {
            var store = _stores.get(UUID);

            var $elements = _this2.element().find('input,select,textarea');

            $("#fe-title-".concat(UUID)).html(store.get('title'));

            for (var i = 0; i < $elements.length; ++i) {
              var editor = _this2.getEditor($elements[i].name);

              if (editor && !editor.option('disabled') && editor.option('visible')) {
                editor.focus();
                break;
              }
            }

            function labelClick(e) {
              var input = $("#".concat($(e.currentTarget).attr('for')));
              input.trigger('focus');
              input.trigger('select');
            }

            var $labels = $('.dx-field-item-label');
            $labels.off('click', labelClick);
            $labels.on('click', labelClick);
            store = store.set('initialized', true);
            _stores = _stores.set(UUID, store);
            that.emit(CHANGE_EVENT);
          }, 600);
        },
        onDisposing: function onDisposing(e) {}
      });
      store = store.set('formInst', form);

      if (store.get('popupInst')) {
        store.get('popupInst').dxPopup("show");
      }

      _stores = _stores.set(UUID, store);
    }
  }, {
    key: "createFieldsGroup",
    value: function createFieldsGroup() {
      return {
        itemType: 'group',
        colCount: 1,
        items: []
      };
    }
  }, {
    key: "addFieldsToGroup",
    value: function addFieldsToGroup(group, UUID) {
      var _this3 = this;

      var setField = function setField(field) {
        var isRequired = field[Fields.ObjectFieldID_IsRequired];
        return {
          label: {
            text: window.D5.isDebugMode() ? "".concat(field[Fields.Title], " {").concat(field[Fields.Name], "}") : field[Fields.Title],
            location: getTitlePosition(field),
            showColon: getTitlePosition(field) !== 'right',
            visible: Boolean(field[Fields.IsShowTitle])
          },
          'Order': field[Fields.Order],
          dataField: field.Name,
          visible: Boolean(field[Fields.IsVisible]),
          isRequired: isRequired,
          template: function template(data, itemElement) {
            var component = data.component,
                dataField = data.dataField;

            _this3.initField(field, component, dataField, itemElement, UUID);
          }
        };
      };

      var store = _stores.get(UUID);

      var objectFields = _.sortBy(store.get('objectFields'), Fields.Order); //перебор настроек полей


      _.each(objectFields, function (field) {
        group['items'].push(setField(field));
      });
    }
  }, {
    key: "initField",
    value: function initField(field, formInst, dataField, itemElement, UUID) {
      var dictObj = getLinkedName(field);
      var dictKeyFld = getKeyObjFieldName(field);
      var dictDisplayFld = getDisplayObjectFieldIDName(field);
      var type = getD5EditorType(field);
      var typeField = getControlDXType(field);
      var dxDateBox = System.DX_CONTROLS.dxDateBox;

      var store = _stores.get(UUID);

      var initDropDown = function initDropDown(e) {
        setTimeout(function () {
          var $overlay = $('.dx-dropdowneditor-overlay'),
              $popupContent = $overlay.find('.dx-popup-content');
          $popupContent.css({
            'max-height': '278px'
          });
        });
      };

      var fValue = formInst.option('formData')[dataField];
      var dsOptions = {
        dictObj: dictObj,
        dictKeyFld: dictKeyFld,
        dictDisplayFld: dictDisplayFld,
        dataField: dataField,
        UUID: UUID
      };
      var props = {
        dataField: dataField,
        objectName: store.get('objectName'),
        dType: type,
        _id: "form-".concat(dataField),
        dataSource: this.createSelectFieldDS(dsOptions),
        displayExpr: dictDisplayFld,
        valueExpr: dictKeyFld,
        value: fValue,
        allowNullState: false,
        onValueChanged: function onValueChanged(_ref2) {
          var value = _ref2.value;

          var store = _stores.get(UUID);

          var formData = store.get('formData');
          var val = value;

          if (type === System.FIELD_EDITOR_TYPE.DATE && val) {
            if (typeof val === 'string') {
              val = new Date(val);
            } else if (Array.isArray(val)) {
              val = val.map(function (date) {
                return typeof date === 'string' ? new Date(date) : date;
              });
            }
          }

          formData[dataField] = val;
          _stores = _stores.set(UUID, store.set('formData', formData));
          formInst.updateData(dataField, value);
        },
        onOpened: function onOpened(e) {
          if (type === System.FIELD_EDITOR_TYPE.SELECT) initDropDown(e);
        },
        onContentReady: function onContentReady(e) {
          if (type === System.FIELD_EDITOR_TYPE.SELECT) initDropDown(e);
        }
      };

      if (typeField === dxDateBox) {
        props.placeholder = getDatePlaceholder(getFieldFormat(field));
        props.showClearButton = true;
        props.useMaskBehavior = true;
        props.type = getFieldFormat(field);

        if (field[Fields.DisplayType] === 4) {
          props.displayCustomParam = field[Fields.DisplayCustomParam];
          props.displayType = field[Fields.DisplayType];
        }
      }

      var editor = FieldsFactory.create(type, props);
      var el = editor.element();
      el.appendTo(itemElement);
    }
  }, {
    key: "prepareFields",
    value: function prepareFields(UUID) {
      var group = this.createFieldsGroup();
      this.addFieldsToGroup(group, UUID);
      return group;
    }
  }, {
    key: "instance",
    value: function instance(UUID) {
      var store = _stores.get(UUID);

      return store && store.get('formInst').dxForm('instance');
    }
  }, {
    key: "updateForm",
    value: function updateForm(_ref3) {
      var UUID = _ref3.UUID,
          nextData = _ref3.nextData;

      var store = _stores.get(UUID);

      this.instance().option('formData', nextData);
      if (nextData) store = store.set('formData', nextData);
      _stores = _stores.set(UUID, store);
    }
  }, {
    key: "cancelForm",
    value: function cancelForm(UUID) {
      var store = _stores.get(UUID);

      if (store.get('viewMode') === System.VIEW_MODE.MODAL) store.get('popupInst').dxPopup('hide');
      this.navigateToParent(UUID);
    }
  }, {
    key: "apply",
    value: function apply(_ref4) {
      var _this4 = this;

      var UUID = _ref4.UUID;

      var store = _stores.get(UUID);

      var formData = store.get('formData');
      var _System$DX_CONTROLS = System.DX_CONTROLS,
          dxDateBox = _System$DX_CONTROLS.dxDateBox,
          dxCheckBox = _System$DX_CONTROLS.dxCheckBox;
      var reportURL = store.get('reportUrl').replace(/^\/|\/$/g, '');
      var operation = router.createUrl('read', store.get('objectName'));
      var url = document.location.origin + operation + (reportURL ? "/".concat(reportURL) : '');
      url = new URL(url);
      var hostStr = !url.search ? 'host=' : '&host=';

      if (url.href.lastIndexOf('?') !== url.href.length - 1 && !url.search) {
        url.href += '?';
      }

      var fieldsStr = _.map(formData, function (value, key) {
        var val = value;

        var field = _this4.getFieldByName(key, UUID);

        var typeField = getControlDXType(field);
        var objFldName = field[Fields.ObjectFieldID_Name];

        if (Array.isArray(val)) {
          val = value.join(',');
        } else if (typeField === dxDateBox) {
          val = formatDateToAPI(new Date(val), field[Fields.ObjectFieldID_IsTimeAllowed]);
        } else if (typeField === dxCheckBox) {
          val = Number(val);
        } else if (val == null) {
          return '';
        }

        return "".concat(objFldName, "=").concat(val);
      });

      var stateManager = store.get('stateManager');
      stateManager.setProperty(System.FORM_STATE_PROPS.FIELDS, formData);
      stateManager.write();
      window.open(url.href + hostStr + document.domain + '&' + decodeURI(fieldsStr.join('&'))); // let newWin = window.open();
      // newWin.document.location = url.href + hostStr + document.domain + '&' + decodeURI(fieldsStr.join('&'));
      // https://teamtrack.macc.com.ua/view.php?id=60429
    }
  }, {
    key: "validate",
    value: function validate(UUID) {
      var res = this.instance(UUID).validate();

      if (res && Array.isArray(res.brokenRules) && res.brokenRules.length) {
        throw new Error(res.brokenRules.map(function (err) {
          return err.message;
        }).join('<br/>'));
      }
    }
  }, {
    key: "destroy",
    value: function destroy(UUID) {
      if (UUID != null) _stores = _stores.delete(UUID);else _stores.clear();
    }
  }]);

  return FormReportStoreClass;
}(StoreClass);

var FormReportStore = new FormReportStoreClass();
AppDispatcher.register(function (action) {
  var st = FormReportStore;
  var store = {};

  switch (action.actionType) {
    case FormReportConstants.FORM_REPORT_INITIALIZE:
      var _action$formObj = action.formObj,
          formID = _action$formObj.formID,
          UUID = _action$formObj.UUID,
          viewMode = _action$formObj.viewMode,
          additionalData = _action$formObj.additionalData;

      var _ref5 = additionalData || {},
          reportUrl = _ref5.reportUrl,
          _ref5$data = _ref5.data,
          data = _ref5$data === void 0 ? {} : _ref5$data;

      Promise.all([loadFormMetadata(formID), loadFormFields(formID)]).then(function (resp) {
        var formFields = resp[1],
            meta = resp[0];
        _stores = _stores.set(UUID, new ReportStore({
          formID: formID,
          viewMode: viewMode,
          formInst: action.formInst,
          popupInst: action.popupInst,
          tableUUID: action.tableUUID,
          objectName: meta[Fields.ObjectID_Name],
          title: meta[Fields.Title] || Messages.Controls.Report,
          reportUrl: reportUrl || '',
          objectFields: formFields,
          stateManager: new FormStateManager({
            formID: formID
          })
        }));
        _stores = _stores.set(UUID, _stores.get(UUID).set('formData', FormReportStore.sourceDataToForm(UUID, data)));
        formReportUpdate({
          UUID: UUID
        });
      });
      break;

    case FormReportConstants.FORM_REPORT_NAVIGATE_TO_PARENT:
      FormReportStore.cancelForm(action.UUID);
      break;

    case FormReportConstants.FORM_REPORT_UPDATE:
      if ($(_stores.get(action.UUID).get('formInst')).data('dxForm')) {
        st.updateForm(action);
      } else {
        st.initForm(action);
      }

      store = _stores.get(action.UUID);
      _stores = _stores.set(action.UUID, store.set('updating', false));
      break;

    case FormReportConstants.FORM_REPORT_APPLY:
      try {
        FormReportStore.validate(action.UUID);
        FormReportStore.apply(action);
      } catch (e) {
        showSnackBar({
          type: System.SNACKBAR_TYPES.Error,
          message: e.message
        });
      }

      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        FormReportStore.destroy();
        break;
      }

    default:
      return true;
  }
});
export default FormReportStore;